import React from 'react';
import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
//import { toast } from 'react-toastify';
import { useAppSelector, useAppDispatch } from '../../Core/hooks';
import { getUser, login, setLoggingIn } from '../../Store/Auth';
import Footer from '../../Components/Footer';
import Navigation from '../../Components/Navigation';
//import Registration from '../../Modals/Registration';
//import Login from '../../Modals/Login';
import PricingTiers from '../../Components/PricingTiers';
import { isValidEmail } from '../../Helpers/isValidEmail';
import { joinWaitlist } from '../../Store/Utility';
import { HiArrowLongRight } from "react-icons/hi2";
import { IoCheckmarkCircleOutline } from "react-icons/io5";

function Home() {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const user = useAppSelector(getUser);
    const [email, setEmail] = useState<string>("");
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [error, setError] = useState<boolean>(false);
    const [success, setSuccess] = useState<boolean>(false);
    //const toastId = React.useRef(0);
    //const [showLogin, setShowLogin] = useState(false);
    //const [showRegistration, setShowRegistration] = useState(false);
    //const [activationCode, setActivationCode] = useState<string | null>(null);
    //const [recoveryCode, setRecoveryCode] = useState<string | null>(null);
    //const [queryParams] = useSearchParams();
    // Get a specific query parameter
    

    useEffect(() => {
        window.scrollTo(0, 0);
        //setActivationCode(queryParams.get('ac'));
        //setRecoveryCode(queryParams.get('ar'));
    }, []);
/*
    useEffect(()=>{
        if (activationCode) {
            setShowLogin(true);
        }
    },[activationCode]);
*/
    useEffect(() => {
        if (user.accessToken !== "" && user.status !== "loading"){
            //dispatch(setLoggingIn(false));
            //navigate('/members/login');
            navigate('/dash');
        }
    }, [user]);

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
    }
    const handleFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFirstName(e.target.value);
    }
    const handleLastNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLastName(e.target.value);
    }
    const handleJoinWaitlist = (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement>) => {

        e.preventDefault();

        if (e.type === "keydown" ) {
            let keypress = e as React.KeyboardEvent;
            if (keypress.key !== 'Enter') {
                return;
            }            
        }
        
        if (!isValidEmail(email) || firstName === "" || lastName === "") {
            setError(true);
            setTimeout(() => setError(false), 2000);
        } else {
            setEmail("");
            setFirstName("");
            setLastName("");
            setSuccess(true);
            setTimeout(() => setSuccess(false), 2000);
            dispatch(joinWaitlist({
                firstName: firstName,
                lastName: lastName,
                email: email,
                marketingSource: "home page: top join waitlist form"
            }));
        }
    }
/*
    const toggleLogin = (visible: boolean) => {
        setShowRegistration(false);
        setShowLogin(visible);
    }
 
    const toggleRegistration = (visible: boolean) => {
        setShowLogin(false);
        setShowRegistration(visible);
    }

    const showRegistrationModal = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        setShowRegistration(true);
    }
*/
    return (
    <>
        <Navigation />
        <div style={{ backgroundColor: "#02152a", paddingBottom: "50px" }}>
            <div className="homeSplashContainer">
                {/*
                <div>
                    <div className="homeSplashLeft">
                        <h1 className="homePageHeader">
                            <strong>From Idea to Launch</strong> - <em>All in One Workspace
                                <img src="images/squiggle.svg" className="squiggleSvg" />
                            </em>
                        </h1>
                        <p style={{ color: "#fff", fontSize: "20px", lineHeight: "28px", fontWeight: "450px" }}>
                            Roadmaps that guide you, boards that organize you, and real-time chat to move fast.
                            Plan smarter, stay aligned, and bring your ideas to life faster than ever.
                        </p> 
                    </div>
                    <div className="homeSplashMiddle"></div>
                    <div className="homeSplashRight">
                        <div className="homeJoinWaitlistTitle">
                            Join the Waitlist
                        </div>
                        <div className="homeWaitlistBlurb" style={{ color: "#cacfd2", fontSize: "14pt", paddingTop: "10px", paddingBottom: "10px" }}>
                            Be the first to experience Herdr.io! Join our waitlist to get early access 
                            and stay updated on our launch.
                        </div>
                        {error &&
                            <div className="error" style={{ marginTop: "10px" }}>
                                Please enter all fields
                            </div>
                        }
                        {success &&
                            <div className="success" style={{ marginTop: "10px" }}>
                                You're on the list!
                            </div>
                        }
                        <input type="input" style={{ marginTop: "10px" }} className="form-control" placeholder="Email Address" 
                            value={email}
                            onChange={(e) => handleEmailChange(e)} />
                        <input type="input" style={{ marginTop: "10px" }} className="form-control" placeholder="First Name"
                            value={firstName}
                            onChange={(e) => handleFirstNameChange(e)} />
                        <input type="input" style={{ marginTop: "10px" }} className="form-control" placeholder="Last Name" 
                            value={lastName}
                            onChange={(e) => handleLastNameChange(e)} />
                        <button className="yellowButton" style={{ width: "100%", marginTop: "10px" }}
                            onClick={(e) => handleJoinWaitlist(e)} onKeyDown={(e) => handleJoinWaitlist(e)}>
                            Get Launch Updates
                        </button>
                        <Registration inline={true} visible={true} visibleHandler={toggleRegistration} />
                    </div>
                </div>
                */}
                <div className="desktop" style={{ alignItems: "start", justifyContent: "space-between", gap: "70px" }}>
                    <div style={{ flex: 1, textAlign: "left" }}>
                        <div style={{ fontSize: "16pt", color: "#fff", fontWeight: 450 }}>
                            <img src="images/herdr-logo-cat-only.png" width="36px" 
                                style={{ paddingRight: "5px", position: "relative", top: "-6px" }}
                            />
                            <span style={{ fontWeight: "bold"}}>herdr</span> chat, roadmaps, boards, and dashes
                        </div>
                        <h1 style={{ color: "#fff", fontSize: "30pt", fontWeight: 700 }}>
                            Your Complete Startup Toolkit
                        </h1>
                        <p style={{
                            margin: "30px auto 0px auto",
                            color: "#fff",
                            fontSize: "16pt",
                            fontWeight: 550
                        }}>
                            Roadmaps that guide you, boards that organize you, and real-time chat to move fast.
                            Plan smarter, execute faster, stay aligned, and bring your ideas to life faster than ever.
                        </p>
                        <div style={{ marginTop: "45px" }}>
                            <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-top");}}
                                className="greenButton" style={{ padding: "12px 36px", fontWeight: 500,
                                    fontSize: "16pt", textDecoration: "none", color: "#fff"
                            }}>
                                Join Free <HiArrowLongRight size={30} color="#fff" />
                            </Link>
                        </div> 
                    </div>

                    <div style={{ flex: 1 }}>
                        <a href="#splash-section"><img src="images/herdr-home-collage-master.png" style={{ width: "100%" }} /></a>
                    </div>
                </div>
                <div className="mobile" style={{ width: "90%", margin: "0px auto" }}>
                    <div style={{ textAlign: "left" }}>
                        <div style={{ fontSize: "16pt", color: "#fff", fontWeight: 450 }}>
                            <img src="images/herdr-logo-cat-only.png" width="36px" 
                                style={{ paddingRight: "5px", position: "relative", top: "-6px" }}
                            />
                            <span style={{ fontWeight: "bold"}}>herdr</span> chat, roadmaps, boards, and dashes
                        </div>
                        <h1 style={{ marginTop: "20px", color: "#fff", fontSize: "30pt", fontWeight: 700 }}>
                            Your Complete Startup Toolkit
                        </h1>
                        <p style={{
                            margin: "30px auto 0px auto",
                            color: "#fff",
                            fontSize: "16pt",
                            fontWeight: 550
                        }}>
                            Roadmaps that guide you, boards that organize you, and real-time chat to move fast.
                            Plan smarter, execute faster, stay aligned, and bring your ideas to life faster than ever.
                        </p>
                        <div style={{ marginTop: "45px" }}>
                            <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-top");}}
                                className="greenButton" style={{ padding: "12px 36px", fontWeight: 500,
                                    fontSize: "16pt", textDecoration: "none", color: "#fff"
                            }}>
                                Join Free <HiArrowLongRight size={30} color="#fff" />
                            </Link>
                        </div> 
                    </div>

                    <div style={{ marginTop: "40px" }}>
                        <a href="#splash-section"><img src="images/herdr-home-collage-master.png" style={{ width: "100%" }} /></a>
                    </div>
                </div>
            </div>
        </div>  


        <div className="mobile80width" style={{ textAlign: "center", padding: "40px 20px 20px 20px", maxWidth: "1000px", margin: "0 auto" }}>
            <h1 style={{ fontSize: "3rem", fontWeight: "700", marginBottom: "10px" }}>
                Build your startup faster with Herdr
            </h1>
            <p style={{ lineHeight: "1.2", fontSize: "2rem", marginBottom: "40px", fontWeight: "500" }}>
                From idea to launch - all in one workspace
            </p>
            <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "30px" }}>
                <ul style={{ listStyle: "none", padding: 0, textAlign: "left", fontSize: "1.5rem" }}>
                    <li style={{ marginBottom: "20px" }}>
                        <IoCheckmarkCircleOutline color="#e55c02" size={40} /> Brainstorm, prioritize, and organize ideas
                    </li>
                    <li style={{ marginBottom: "20px" }}>
                        <IoCheckmarkCircleOutline color="#e55c02" size={40} /> Create shareable roadmaps for your team or investors
                    </li>
                    <li style={{ marginBottom: "20px" }}>
                        <IoCheckmarkCircleOutline color="#e55c02" size={40} /> Track progress with intuitive kanban boards
                    </li>
                    <li style={{ marginBottom: "20px" }}>
                        <IoCheckmarkCircleOutline color="#e55c02" size={40} /> Collaborate in real time with built-in chat
                    </li>
                    <li style={{ marginBottom: "20px" }}>
                        <IoCheckmarkCircleOutline color="#e55c02" size={40} /> Stay focused with just what you need - no clutter
                    </li>
                </ul>
            </div>
        </div>

        {/*
        <div className="homeCustomerSegmentContainer">
            <div className="homeCustomerSegmentContainerInner">
                <span className="customerSegmentBullet1">SIMPLIFY PLANNING.</span>
                <span className="customerSegmentBullet2">TRACK PROGRESS.</span>
                <span className="customerSegmentBullet2">DRIVE RESULTS.</span>
            </div>
            <div className="customerSegmentContainer1">
                <Link to="/tech-startup-founders" className="homeCustomerSegmentLink">
                    <div className="customerSegmentBox1">
                        <div style={{ textTransform: "uppercase", fontSize: "10pt", paddingBottom: "10px"}}>
                            Simplify organizing ideas and planning
                        </div>
                        <h2 style={{ fontSize: "14pt", fontWeight: "bold" }}>Tech Startup Founders</h2>
                        <p>
                            Remove the complexity and stay focused and aligned, from concept to execution.	
                        </p>
                    </div>
                </Link>
                <Link to="/creative-agencies" className="homeCustomerSegmentLink">
                    <div className="customerSegmentBox2">
                        <div style={{ textTransform: "uppercase", fontSize: "10pt", paddingBottom: "10px"}}>
                            Connect big-picture goals with daily tasks
                        </div>
                        <h2 style={{ fontSize: "14pt", fontWeight: "bold" }}>Creative Agencies</h2>
                        <p>
                            Keep your team 
                            aligned and efficient, so you can focus on delivering results, 
                            not managing chaos.	
                        </p>
                    </div>
                </Link>
                <Link to="/freelancers" className="homeCustomerSegmentLink">
                    <div className="customerSegmentBox3">
                        <div style={{ textTransform: "uppercase", fontSize: "10pt", paddingBottom: "10px"}}>
                            Coordinate without the need for hierarchies
                        </div>
                        <h2 style={{ fontSize: "14pt", fontWeight: "bold" }}>Freelance Collaboratives</h2>
                        <p>
                            Keep freelancers organized and aligned, enabling smooth collaboration across projects.	
                        </p>
                    </div>
                </Link>
                <Link to="/product-designers" className="homeCustomerSegmentLink">
                    <div className="customerSegmentBox4">
                        <div style={{ textTransform: "uppercase", fontSize: "10pt", paddingBottom: "10px"}}>
                            Streamline design from ideation to delivery
                        </div>
                        <h2 style={{ fontSize: "14pt", fontWeight: "bold" }}>Product Designers and UX Teams</h2>
                        <p>
                            Keep your team organized and aligned, whether you're prototyping a mobile 
                            app or refining your latest design.	
                        </p>
                    </div>
                </Link>
            </div>

            <div className="customerSegmentContainer2">
                <Link to="/bootstrapped-entrepreneurs" className="homeCustomerSegmentLink">
                    <div className="customerSegmentBox1">
                        <div style={{ textTransform: "uppercase", fontSize: "10pt", paddingBottom: "10px"}}>
                            streamline your workflow without the complexity
                        </div>                    
                        <h2 style={{ fontSize: "14pt", fontWeight: "bold" }}>Bootstrapped Entrepreneurs</h2>
                        <p>
                            Track progress and manage tasks without the complexity, 
                            allowing you to focus on growing your business.
                        </p>
                    </div>
                </Link>
                <Link to="/small-nonprofits" className="homeCustomerSegmentLink">
                    <div className="customerSegmentBox2">
                        <div style={{ textTransform: "uppercase", fontSize: "10pt", paddingBottom: "10px"}}>
                            focus on making an impact
                        </div> 
                        <h2 style={{ fontSize: "14pt", fontWeight: "bold" }}>Small Nonprofits</h2>
                        <p>
                            Whether you're managing multiple nonprofit initiatives or coordinating community events, 
                            stay on track without added complexity.	
                        </p>
                    </div>
                </Link>
                <Link to="/academic-research-teams" className="homeCustomerSegmentLink">
                    <div className="customerSegmentBox3">
                        <div style={{ textTransform: "uppercase", fontSize: "10pt", paddingBottom: "10px"}}>
                            focus on experiments and publications
                        </div> 
                        <h2 style={{ fontSize: "14pt", fontWeight: "bold" }}>Academic Research Teams</h2>
                        <p>
                            With streamlined workflows, trackable deadlines, and easily managed tasks
                        </p>
                    </div>
                </Link>
                <Link to="/software-development-teams" className="homeCustomerSegmentLink">
                    <div className="customerSegmentBox4">
                        <div style={{ textTransform: "uppercase", fontSize: "10pt", paddingBottom: "10px"}}>
                            Support fast development without the complexity
                        </div> 
                        <h2 style={{ fontSize: "14pt", fontWeight: "bold" }}>Small Software Development Teams</h2>
                        <p>
                            Large project management platforms are too complex. 
                            Whether you're building a plugin or working on a software project, stay organized and efficient.
                        </p>
                    </div>
                </Link>
            </div>

            <div className="customerSegmentContainer3">
                <Link to="/consultants-coaches" className="homeCustomerSegmentLink">
                    <div className="customerSegmentBox1">
                        <div style={{ textTransform: "uppercase", fontSize: "10pt", paddingBottom: "10px"}}>
                            guide clients through roadmaps and tasks
                        </div> 
                        <h2 style={{ fontSize: "14pt", fontWeight: "bold" }}>Consultants and Coaches</h2>
                        <p>
                            Organize projects, track progress, and provide 
                            clear direction, making it easy to support your clients and ensure their success.
                        </p>
                    </div>
                </Link>
                <Link to="/ecommerce-teams" className="homeCustomerSegmentLink">
                    <div className="customerSegmentBox2">
                        <div style={{ textTransform: "uppercase", fontSize: "10pt", paddingBottom: "10px"}}>
                            Manage product launches and marketing campaigns
                        </div> 
                        <h2 style={{ fontSize: "14pt", fontWeight: "bold" }}>Small E-Commerce Teams</h2>
                        <p>
                            Help your team stay organized and efficient as you launch new products and drive sales.
                        </p>
                    </div>
                </Link>
                <Link to="/company-executives" className="homeCustomerSegmentLink">
                    <div className="customerSegmentBox3">
                        <div style={{ textTransform: "uppercase", fontSize: "10pt", paddingBottom: "10px"}}>
                            Manage Strategic Initiatives
                        </div> 
                        <h2 style={{ fontSize: "14pt", fontWeight: "bold" }}>Small and Mid-Size Company Executives</h2>
                        <p>
                            Keep your teams aligned and on track as you roll out new products, execute marketing 
                            campaigns, and scale operations effectively.
                        </p>
                    </div>
                </Link>
            </div>
        </div>
        */}

        <div className="homeOrangeWave">  
            {/*
            <div className="homePricingTitle">
                Simplified Pricing
            </div>
            */}          
            <div className="wave">
                <svg name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
                </svg>
            </div>
            <div className="homePagePricingTiersContainer">
                <PricingTiers 
                    mostPopularButtonBackgroundColor='#000' 
                    mostPopularButtonColor='#fff'
                    mostPopularButtonBorder='3px solid #e55c02' 
                    page="home"
                />
            </div>
        </div>

        <div id="splash-section" >
            <div className="mobile80width homeSplashContainer" style={{ position: "relative" }}>
                <div style={{ margin: "40px 0px 60px 0px" }}>
                    <div className="feature-blurb" style={{ margin: "0px auto 60px auto" }}>
                        <h2 style={{ textAlign: "center", fontWeight: "600", fontSize: "2rem", marginBottom: "20px" }}>
                            Plan Like a Boss. Execute Without the Chaos.
                        </h2>
                        <div style={{ fontSize: "1.4rem", textAlign: "justify", color: "#555" }}>
                            Strategic roadmaps meet real execution. Connect your big-picture plans to 
                            actionable Kanban boards, track progress intuitively, and keep your team 
                            aligned with live dashboards and smart workflows.
                        </div>
                    </div>
                    <div style={{ width: "100%" }}>
                        <div>
                            <img src="/images/roadmap-01.jpg" style={{ width: "100%" }} />
                        </div>
                    </div>
                </div>
                <div style={{ width: "100%", margin: "0px auto 60px auto"  }}>
                    <div className="feature-blurb" style={{ margin: "0px auto 60px auto" }}>
                        <div style={{ marginTop: "10px", marginBottom: "60px", textAlign: "center" }}>
                            <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-roadmap-button");}}
                                className="orangeButton" style={{ padding: "12px 36px", fontWeight: 500,
                                    fontSize: "16pt", textDecoration: "none", color: "#fff"
                            }}>
                                Build Your Roadmap <span className="hideForMobile"><HiArrowLongRight size={30} color="#fff" /></span>
                            </Link>
                        </div>
                        <h2 style={{ textAlign: "center", fontWeight: "600", fontSize: "2rem", marginBottom: "20px" }}>
                            Focus More. Click Less. Kanban Reinvented.
                        </h2>
                        <div style={{ fontSize: "1.4rem", textAlign: "justify", color: "#555" }}>
                            No due dates. Forget setting deadlines for every task. Our intuitive 
                            board statuses, automatic completion tracking, and built-in stopwatch let your 
                            team stay focused and flexible. This is Kanban reimagined for Web 3.0 - fewer clicks, 
                            smarter flow, and built for real agile work.
                        </div>
                    </div>
                    <div style={{ width: "100%" }}>
                        <div>
                            <img src="/images/kanban-02.jpg" style={{ width: "100%" }} />
                        </div>
                    </div>
                </div>
                <div style={{ width: "100%", margin: "0px auto 60px auto"  }}>
                    <div className="feature-blurb" style={{ margin: "0px auto 60px auto" }}>
                        <div style={{ marginTop: "10px", marginBottom: "60px", textAlign: "center" }}>
                            <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-kanban-button");}}
                                className="orangeButton" style={{ padding: "12px 36px", fontWeight: 500,
                                    fontSize: "16pt", textDecoration: "none", color: "#fff"
                            }}>
                                Try Smarter Kanban <span className="hideForMobile"><HiArrowLongRight size={30} color="#fff" /></span>
                            </Link>
                        </div>
                        <h2 style={{ textAlign: "center", fontWeight: "600", fontSize: "2rem", marginBottom: "20px" }}>
                            Simple Reports & Dashboards That Keep You Focused
                        </h2>
                        <div style={{ fontSize: "1.4rem", textAlign: "justify", color: "#555" }}>
                            Stay on top of what matters with intuitive dashboards that give you visibility 
                            across every project, task, and roadmap - all in one place. Track progress, 
                            spot blockers, and keep your team aligned.
                        </div>
                    </div>
                    <div style={{ width: "100%" }}>
                        <div>
                            <img src="/images/dashboard-01.jpg" style={{ width: "100%" }} />
                        </div>
                    </div>
                </div>
                <div style={{ width: "100%", margin: "0px auto 60px auto"  }}>
                    <div className="feature-blurb" style={{ margin: "0px auto 60px auto" }}>
                        <div style={{ marginTop: "10px", marginBottom: "60px", textAlign: "center" }}>
                            <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-dash-button");}}
                                className="orangeButton" style={{ padding: "12px 36px", fontWeight: 500,
                                    fontSize: "16pt", textDecoration: "none", color: "#fff"
                            }}>
                                See Your Work Clearly <span className="hideForMobile"><HiArrowLongRight size={30} color="#fff" /></span>
                            </Link>
                        </div>
                        <h2 style={{ textAlign: "center", fontWeight: "600", fontSize: "2rem", marginBottom: "20px" }}>
                            Integrated Team Chat for Seamless, Connected Collaboration
                        </h2>
                        <div style={{ fontSize: "1.4rem", textAlign: "justify", color: "#555" }}>
                            Stay aligned without switching tools. Slack-style channels and direct messages 
                            are fully integrated with your Kanban boards and roadmaps - so you can comment on 
                            a card, start a conversation, or jump into a project thread without missing a beat.
                        </div>
                    </div>
                    <div style={{ width: "100%" }}>
                        <div>
                            <img src="/images/chat-01.jpg" style={{ width: "100%" }} />
                        </div>
                    </div>
                </div>
                <div style={{ width: "100%", margin: "0px auto 60px auto"  }}>
                    <div className="feature-blurb" style={{ margin: "0px auto 60px auto" }}>
                        <div style={{ marginTop: "10px", marginBottom: "60px", textAlign: "center" }}>
                            <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-chat-button");}}
                                className="orangeButton" style={{ padding: "12px 36px", fontWeight: 500,
                                    fontSize: "16pt", textDecoration: "none", color: "#fff"
                            }}>
                                Chat Where Work Happens <span className="hideForMobile"><HiArrowLongRight size={30} color="#fff" /></span>
                            </Link>
                        </div>
                        <h2 style={{ textAlign: "center", fontWeight: "600", fontSize: "2rem", marginBottom: "20px" }}>
                            Share Roadmaps and Projects - No Paywall, No Friction
                        </h2>
                        <div style={{ fontSize: "1.4rem", textAlign: "justify", color: "#555" }}>
                            Invite collaborators without worrying about cost. Share your roadmaps and projects 
                            freely - no paid seats, no upgrades required. Built to empower lean teams to build 
                            great things together.
                        </div>
                    </div>
                    <div style={{ width: "100%" }}>
                        <div>
                            <img src="/images/collaboration-01.jpg" style={{ width: "100%" }} />
                        </div>
                        <div style={{ marginTop: "60px", marginBottom: "60px", textAlign: "center" }}>
                            <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-collaborate-button");}}
                                className="orangeButton" style={{ padding: "12px 36px", fontWeight: 500,
                                    fontSize: "16pt", textDecoration: "none", color: "#fff"
                            }}>
                                Share Without Limits <span className="hideForMobile"><HiArrowLongRight size={30} color="#fff" /></span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style={{ backgroundColor: "#02152a" }}>
            <div className="mobile80width homeSplashContainer" style={{ position: "relative" }}>
                <h2 style={{ margin: "40px 0px", color: "#fff", fontWeight: "600", fontSize: "2.6rem"}}>
                    Why startups love Herdr.io
                </h2>
                <div className="desktopFlex">
                    <div className="desktopInlineBlock" style={{
                        boxShadow: "4px 4px 14px 0px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#fff",
                        borderRadius: "20px",
                        borderColor: "#fff",
                        textAlign: "left",
                        padding: "20px",
                        height: "250px",
                    }}>
                        <div style={{ fontSize: "14pt", fontWeight: "bold", marginBottom: "20px" }}>
                            From Idea to Launch, Fast
                        </div>
                        <div>
                            Herdr helps founders move quickly from brainstorming to execution with roadmaps, boards, 
                            and real-time chat - no bloated features, just what startups need.
                        </div>
                    </div>
                    <div className="mobileMarginTop20 desktopInlineBlock desktopLeftMargin20" style={{
                        boxShadow: "4px 4px 14px 0px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#fff",
                        borderRadius: "20px",
                        borderColor: "#fff",
                        textAlign: "left",
                        padding: "20px",
                        height: "250px",
                    }}>
                        <div style={{ fontSize: "14pt", fontWeight: "bold", marginBottom: "20px"}}>
                            Built for Lean, Scrappy Teams
                        </div>
                        <div>
                            Track what's happening, what's blocked, and what's next - all in one place. 
                            Herdr brings visibility to fast-moving teams without slowing them down.
                        </div>
                    </div>
                </div>
                <div className="desktopFlex" style={{ marginTop: "20px"}}>
                    <div  className="desktopInlineBlock" style={{
                        boxShadow: "4px 4px 14px 0px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#fff",
                        borderRadius: "20px",
                        borderColor: "#fff",
                        textAlign: "left",
                        padding: "20px",
                        height: "250px",
                    }}>
                        <div style={{ fontSize: "14pt", fontWeight: "bold", marginBottom: "20px"}}>
                            Impress Investors & Teammates
                        </div>
                        <div>
                            Share beautiful, interactive roadmaps to keep stakeholders aligned. 
                            Whether you're pitching or onboarding, Herdr makes your vision clear.
                        </div>
                    </div>
                    <div className="mobileMarginTop20 desktopInlineBlock desktopLeftMargin20" style={{
                        boxShadow: "4px 4px 14px 0px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#fff",
                        borderRadius: "20px",
                        borderColor: "#fff",
                        textAlign: "left",
                        padding: "20px",
                        height: "250px",
                    }}>
                        <div style={{ fontSize: "14pt", fontWeight: "bold", marginBottom: "20px"}}>
                            Collaborate Without the Noise
                        </div>
                        <div>
                            Integrated chat keeps conversations tied to tasks and 
                            roadmaps, so you never lose context or momentum.
                        </div>
                    </div>
                </div>
                <div style={{ paddingBottom: "75px" }}></div>
                <img src="images/man-woman.png"  style={{ width: "53%", height: "auto", position: "absolute", bottom: "0", right: "-12%" }} />
            </div>
        </div>

        <div className="hideForMobile">
            <div style={{ display: "flex", position: "relative", backgroundColor: "#F8F9FA", padding: "60px 0px" }}>
                <div style={{ display: "inline-block", textAlign: "right", width: "50%", 
                    margin: "0px auto", paddingRight: "80px"
                }}>
                    <img src="images/herdr-orange-logo-cat-v1.png" style={{ width: "200px" }} />
                </div>
                <div style={{ display: "inline-block", textAlign: "left", width: "50%", margin: "0px auto" }}>
                    <h2>Build amazing products</h2>
                    <div style={{ fontSize: "1.5rem" }}>Use Herdr today</div>
                    <div style={{ marginTop: "45px" }}>
                        <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-bottom");}}
                            className="greenButton" style={{ padding: "12px 36px", fontWeight: 500,
                                fontSize: "16pt", textDecoration: "none", color: "#fff"
                        }}>
                            Start For Free <HiArrowLongRight size={30} color="#fff" />
                        </Link>
                    </div> 
                </div>
            </div>
        </div>

        <div className="hideForDesktop" style={{ width: "80%", margin: "0px auto", textAlign: "center" }}>
            <div style={{ position: "relative", padding: "60px 0px" }}>
                <div style={{ display: "inline-block", textAlign: "center", margin: "0px auto" }}>
                    <h2>Build amazing products</h2>
                    <div style={{ fontSize: "1.5rem" }}>Use Herdr today</div>
                    <div style={{ marginTop: "45px" }}>
                        <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-bottom");}}
                            className="greenButton" style={{ padding: "12px 36px", fontWeight: 500,
                                fontSize: "16pt", textDecoration: "none", color: "#fff"
                        }}>
                            Start For Free <HiArrowLongRight size={30} color="#fff" />
                        </Link>
                    </div> 
                </div>
            </div>
        </div>

        {/*<Login visible={showLogin} visibleHandler={toggleLogin} activationCode={activationCode} recoveryCode={recoveryCode} />
        <Registration visible={showRegistration} visibleHandler={toggleRegistration} />*/}
        <Footer style={{ backgroundColor: "#02152a", position: "relative" }} />
    </>
    );
}

export default Home;